export const REGIONS = [
    { name: 'Africa', countries: ['NG', 'ZA', 'EG', 'MA', 'KE', 'ET', 'UG', 'DZ', 'SD', 'AO', 'GH', 'MZ', 'MG', 'CM', 'CI', 'NE', 'ML', 'MW', 'ZM', 'SN', 'TD', 'SO', 'ZW', 'RW', 'BF', 'TN', 'BJ', 'BI', 'TG', 'SL', 'LR', 'MU', 'SZ', 'GN', 'LS', 'GQ', 'GA', 'SC', 'KM', 'DJ'] },
    { name: 'North Africa', countries: ['EG', 'MA', 'DZ', 'TN', 'SD'] },
    { name: 'Southern Africa', countries: ['ZA', 'AO', 'MZ', 'MW', 'ZM', 'ZW', 'SZ', 'LS'] },
    { name: 'North America', countries: ['US', 'CA', 'MX'] },
    { name: 'South America', countries: ['BR', 'AR', 'CO', 'CL', 'PE', 'VE', 'GT', 'EC', 'CU', 'BO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'JM', 'TT', 'LC', 'GD', 'VC', 'BB', 'AG', 'KN', 'DM', 'BL', 'PM'] },
    { name: 'Europe', countries: ['GB', 'FR', 'DE', 'IT', 'ES', 'RU', 'NL', 'BE', 'SE', 'PL', 'NO', 'DK', 'FI', 'CH', 'AT', 'IE', 'PT', 'CZ', 'GR', 'HU', 'RO', 'BG', 'SK', 'HR', 'RS', 'SI', 'MK', 'BA', 'AL', 'ME', 'XK', 'AD', 'LI', 'MT', 'SM', 'VA'] },
    { name: 'Southern Europe', countries: ['IT', 'ES', 'PT', 'GR', 'MT', 'SM', 'VA', 'AL'] },
    { name: 'Central Europe', countries: ['DE', 'PL', 'CZ', 'AT', 'HU', 'SK', 'CH', 'LI'] },
    { name: 'Eastern Europe', countries: ['RU', 'UA', 'RO', 'BG', 'MD', 'BY'] },
    { name: 'Scandinavia', countries: ['SE', 'NO', 'DK', 'FI', 'IS'] },
    { name: 'East Asia', countries: ['CN', 'JP', 'KR', 'MN', 'TW'] },
    { name: 'South East Asia', countries: ['SG', 'ID', 'MY', 'TH', 'PH', 'VN', 'KH', 'LA', 'MM', 'BN', 'TL'] },
    { name: 'Middle East', countries: ['TR', 'IR', 'SA', 'IQ', 'SY', 'YE', 'KW', 'BH', 'QA', 'AE', 'OM', 'JO', 'LB', 'IL'] },
    { name: 'Oceania', countries: ['AU', 'NZ', 'FJ', 'PG', 'SB', 'VU', 'WS', 'TO', 'TV', 'KI', 'FM', 'PW', 'MH', 'NR', 'AS', 'NC', 'PF', 'WF'] }
];
export const REGIONSOPTIONS = [
    { value: 'Africa', label: "Africa" },
    { value: 'North Africa', label: 'North Africa' },
    { value: 'Southern Africa', label: 'Southern Africa' },
    { value: 'North America', label: 'North America' },
    { value: 'South America', label: 'South America' },
    { value: 'Europe', label: 'Europe' },
    { value: 'Southern Europe', label: 'Southern Europe' },
    { value: 'Central Europe', label: 'Central Europe' },
    { value: 'Eastern Europe', label: 'Eastern Europe' },
    { value: 'Scandinavia', label: 'Scandinavia' },
    { value: 'East Asia', label: 'East Asia' },
    { value: 'South East Asia', label: 'South East Asia' },
    { value: 'Middle East', label: 'Middle East' },
    { value: 'Oceania', label: 'Oceania' }
];
